import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const catalogUrl = `${SERVER_API}/catalogs`;

export const measureUrl = `${SERVER_API}/measure-units`;

export const CATALOG_ENDPOINTS = {
  LIST(): IEndpointData {
    return {
      method: 'GET',
      url: `${catalogUrl}`,
    };
  },
  STORE(): IEndpointData {
    return {
      method: 'POST',
      url: `${catalogUrl}`,
    };
  },
  UPDATE(slug: string): IEndpointData {
    return {
      method: 'PUT',
      url: `${catalogUrl}/${slug}`,
    };
  },
  DELETE(slug: string): IEndpointData {
    return {
      method: 'DELETE',
      url: `${catalogUrl}/${slug}`,
    };
  },
  PARENTS_IDS(slug: string): IEndpointData {
    return {
      method: 'GET',
      url: `${catalogUrl}/${slug}/parents-ids`,
    };
  },
};

export const CATALOG_MUNICIPALITIES: IEndpointData = {
  method: 'GET',
  url: `${SERVER_API}/municipalities`,
};

export const CATALOG_VALUE_ENDPOINTS = {
  LIST(slug: string): IEndpointData {
    return {
      method: 'GET',
      url: `${catalogUrl}/${slug}`,
    };
  },
  STORE(slug: string): IEndpointData {
    return {
      method: 'POST',
      url: `${catalogUrl}/${slug}`,
    };
  },
  UPDATE(slug: string, catalogValueId: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${catalogUrl}/${slug}/${catalogValueId.toString()}`,
    };
  },
  DELETE(slug: string, catalogValueId: number): IEndpointData {
    return {
      method: 'DELETE',
      url: `${catalogUrl}/${slug}/${catalogValueId.toString()}`,
    };
  },
};
